import i18n from 'i18n';
import { ModelLicenseType } from 'modules/environments/interfaces';

export const LICENSE_TYPE_NOT_DEFINED_OPTION = 'NOT_DEFINED' as const;

export type LicenseTypeFormValue =
  | ModelLicenseType
  | typeof LICENSE_TYPE_NOT_DEFINED_OPTION;

const LICENSE_TYPE_LABELS: Record<ModelLicenseType, string> = {
  BRING_YOUR_OWN_LICENSE: 'LICENSE_TYPE_BRING_YOUR_OWN_KEY',
  OCI_PROVIDED: 'LICENSE_TYPE_OCI_PROVIDED_KEY',
};

export const toLicenseTypeFormValue = (
  licenseType: ModelLicenseType | null | undefined
): LicenseTypeFormValue =>
  licenseType == null ? LICENSE_TYPE_NOT_DEFINED_OPTION : licenseType;

export const toLicenseTypePayloadValue = (
  value: LicenseTypeFormValue | null | undefined
): ModelLicenseType | null => {
  if (value == null || value === LICENSE_TYPE_NOT_DEFINED_OPTION) {
    return null;
  }
  return value;
};

export const getLicenseTypeDisplayValue = (
  licenseType: ModelLicenseType | null | undefined
): string => {
  if (licenseType == null) {
    return i18n.t('LICENSE_TYPE_NOT_DEFINED_KEY');
  }
  return i18n.t(LICENSE_TYPE_LABELS[licenseType]);
};
